<template>
	<form class='form' @submit.stop.prevent="submit">
		<!-- <h4>Предписания на Акты ЛПО</h4> -->
		<h4>Документарная проверка</h4>
			<div class="row">
				<div class="col-md-1 col">№ акта ЛПО</div>
				<div class="col-md-2 col">Организация</div>
				<div class="col-md-6 col">Ссылка на акт</div>
			</div>
			<div class="row">
				<div class="col-md-1 col"><input type="text" class='form-control my-control' :value='f_2' disabled/></div>
				<div class="col-md-2 col"><organization :org_id='f_11' disabled></organization></div>
				<div class="col-md-6 col act_link"><a :href='f_4'>{{ f_4 }}</a></div>
			</div>
			<div class="row">
				<div class="col-md-3 col">Федеральный округ</div>
				<div class="col-md-3 col">Субъект РФ</div>
				<div class="col-md-3 col">Лесничество</div>
			</div>
			<div class="row">
				<div class="col-md-3 col"><fo :reg_id='f_12'></fo></div>
				<div class="col-md-3 col">
					<region type='warrant' :reg_id='f_12' disabled></region>
				</div>
				<div class="col-md-3 col">
					<forestry type='warrant' :reg_id='f_12' :f_id='f_9' disabled></forestry>
				</div>
			</div>
			<hr>
			<div class="row">
				<div class="col-md-10 col"><b>Документарная проверка</b></div>
			</div>
			<div class="row">
				<div class="col-md-10">
					<table class='documentsTable'>
						<thead>
							<tr>
								<th>Официальные документы</th>
								<th>Дата</th>
								<th>Номер</th>
								<th>Комментарий к документу</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Поступление акта ЛПО в ДЛХ по ФО*</td>
								<td><datepicker
									v-model='f_51'
									format='dd.MM.yyyy'
									:class='(f_71 != 3 && !f_51) ? "field-error-warrant" : ""'
									:disabled='readonly'
									class='table-control'
								></datepicker></td>
								<td><input class="table-control form-control my-control" v-model='f_52' :disabled='readonly'></input></td>
								<td><input class="table-control form-control my-control" v-model='f_53' :disabled='readonly'></input></td>
							</tr>
							<tr>
								<td>Приказ проведения документарной проверки</td>
								<td><datepicker
									v-model='f_54'
									format='dd.MM.yyyy'
									:disabled='readonly'
									class='table-control'
								></datepicker></td>
								<td><input class="table-control form-control my-control" v-model='f_55' :disabled='readonly'></input></td>
								<td><input class="table-control form-control my-control" v-model='f_56' :disabled='readonly'></input></td>
							</tr>
							<tr>
								<td>Акт проведения документарной проверки**</td>
								<td><datepicker
									v-model='f_57'
									format='dd.MM.yyyy'
									:disabled='readonly'
									:class='(f_71 != 3 && !f_57) ? "field-error-warrant-optional" : ""'
									class='table-control'
								></datepicker></td>
								<td><input class="table-control form-control my-control" v-model='f_58' :disabled='readonly'></input></td>
								<td><input class="table-control form-control my-control" v-model='f_59' :disabled='readonly'></input></td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div class="row" v-if='f_42'>
				<div class="col col-md-10 fbu_main_decision">
					<b>Главная причина отрицального заключения ФБУ «Рослесозащита»:</b> {{ f_42_text }}
				</div>
			</div>
			<div style='margin-bottom: 10px'></div>
			<!-- <div>
				<div class="row">
					<div class="col-sm-7" style="margin-bottom: 5px;">
						<input id='btnAddLine' @click='addLine' value='Добавить' type='button' disabled='true' /> <input id='btnDeleteLine' @click='deleteLine' value='Удалить отмеченное' type='button' disabled='true' />
					</div>
				</div>
			</div> -->
			<div class="row">
				<div class="col-sm-12">
					<div class='table_head_wrap'>
						<table class='warrant_place_table warrant_place_table__top' style='margin-bottom: 0px'>
							<thead>
								<tr>
									<th rowspan='2' class="form_td">Участковое лесничество</th>
									<th rowspan='2' class="form_td">Подлес-во</th>
									<th rowspan='2' class="form_td">Квартал</th>
									<th rowspan='2' class="form_td">Выдел</th>
									<th rowspan='2' class="form_td">S выдела</th>
									<th rowspan='2' class="form_td">Лп. Выдел</th>
									<th rowspan='2' class="form_td">S лп. выдела</th>
									<th rowspan='2' class="form_td">МЗЛ</th>
									<th rowspan='2' class="form_td">S МЗЛ</th>
									<th rowspan='2' class="form_td" title='Решение по заключению ФБУ "Рослесозащита"'>Реш-е ФБУ</th>
									<th rowspan='2' class="form_td">Участки требующие проведения выездной проверки</th>
									<th colspan="5" class='colspan_td'>Соответствие сведений</th>
									<th rowspan='2' class="form_td">Решение ДЛХ по ФО*</th>
									<th rowspan='2' class="form_td">Участки требующие проведения выездной проверки</th>
									<th rowspan='2' class="form_td">Комментарии</th>
									<th rowspan='2' :width='scroll_width'></th>
								</tr>
								<tr>
									<!-- <th class="form_td" title='Соответствие сведений данным ГЛПМ'>свед. данным ГЛПМ</th> -->
									<warrant-table-field field_name='f_76' @set='setAccordanceToLocations' title='Соответствие сведений данным ГЛПМ'>
										свед. данным ГЛПМ
									</warrant-table-field>
									<warrant-table-field field_name='f_77' @set='setAccordanceToLocations' title='Соответствие сведений таксационным характеристикам лесного участка'>
										свед. ТО
									</warrant-table-field>
									<warrant-table-field field_name='f_78' @set='setAccordanceToLocations' title='Соответствие  мероприятий данным ГЛПМ'>
										мероприятий данным ГЛПМ
									</warrant-table-field>
									<warrant-table-field field_name='f_79' @set='setAccordanceToLocations' title='Запрещение или ограничение законодательством РФ мероприятий'>
										законодательству РФ
									</warrant-table-field>
									<warrant-table-field field_name='f_80' @set='setAccordanceToLocations' title='Недостоверность сведений санитарному и лесопатологическому состоянию лесов'>
										Недост.свед. Сан. Сост.
									</warrant-table-field>
									<!-- <th class="form_td" title='соответствия сведений таксационным характеристикам лесного участка'>свед. ТО</th>
									<th class="form_td" title='соответствие  мероприятий данным ГЛПМ'>мероприятий данным ГЛПМ</th>
									<th class="form_td" title='запрещение или ограничение законодательством РФ мероприятий'>законодательству РФ</th>
									<th class="form_td" title='недостоверность сведений санитарному и лесопатологическому состоянию лесов'>Недост.свед. Сан. Сост.</th> -->
								</tr>
							</thead>
						</table>
					</div>
					<div class='table_body_wrap'>
						<table id='warrant_table' class='warrant_place_table warrant_place_table__bottom'>
							<tbody>
								<tr v-for='(line, index) in lines'>
									<td class='form_td'>
										<input v-model="line.f_20" class='table-control form-control my-control' disabled></input>
									</td>
									<td class='form_td'>
										<input v-model="line.f_27" class='table-control form-control my-control' disabled></input>
									</td>
									<td class='form_td'>
										<input type="text" class='table-control form-control my-control' v-model='line.f_17' disabled></input>
									</td>
									<td class='form_td'>
										<input type="text" class='table-control form-control my-control' v-model='line.f_24' disabled></input>
									</td>
									<td class='form_td'>
										<input type="text" class='table-control form-control my-control' v-model='line.f_21' disabled></input>
									</td>
									<td class='form_td'>
										<input type="text" class='table-control form-control my-control' v-model='line.f_25' disabled></input>
									</td>
									<td class='form_td'>
										<input type="text" class='table-control form-control my-control' v-model='line.f_23' disabled></input>
									</td>
									<td class='form_td'>
										<input v-model="line.f_16" class='table-control form-control my-control' disabled></input>
									</td>
									<td class='form_td'>
										<input type="text" class='table-control form-control my-control' v-model='line.f_22' disabled></input>
									</td>
									<td class='form_td'>
										<select class='form-control my-control table-control' v-model='line.f_33' disabled>
											<option value="2">Нет данных</option>
											<option value="1">Положительное</option>
											<option value="0">Отрицательное</option>
										</select>
									</td>
									<td class='form_td'>
										<input type="checkbox" v-model='line.f_91' disabled></input>
									</td>
								<td class='form_td'>
									<select class='form-control my-control table-control' v-model='line.f_76' :disabled='readonly' @change='updateViolations'>
										<option value="2">Нет данных</option>
										<option value="1">Соответствует</option>
										<option value="0">Не соответствует</option>
									</select>
								</td>
								<td class='form_td'>
									<select class='form-control my-control table-control' v-model='line.f_77' :disabled='readonly' @change='updateViolations'>
										<option value="2">Нет данных</option>
										<option value="1">Соответствует</option>
										<option value="0">Не соответствует</option>
									</select>
								</td>
								<td class='form_td'>
									<select class='form-control my-control table-control' v-model='line.f_78' :disabled='readonly' @change='updateViolations'>
										<option value="2">Нет данных</option>
										<option value="1">Соответствует</option>
										<option value="0">Не соответствует</option>
									</select>
								</td>
								<td class='form_td'>
									<select class='form-control my-control table-control' v-model='line.f_79' :disabled='readonly' @change='updateViolations'>
										<option value="2">Нет данных</option>
										<option value="1">Соответствует</option>
										<option value="0">Не соответствует</option>
									</select>
								</td>
								<td class='form_td'>
									<select class='form-control my-control table-control' v-model='line.f_80' :disabled='readonly' @change='updateViolations'>
										<option value="2">Нет данных</option>
										<option value="1">Соответствует</option>
										<option value="0">Не соответствует</option>
									</select>
								</td>
								<td class='form_td'>
									<select class='form-control my-control table-control' :class='(f_71 != 3 && line.f_81 == 2) ? "field-error-warrant" : ""' v-model='line.f_81' :disabled='readonly'>
										<option value="2">Нет данных</option>
										<option value="1">Положительное</option>
										<option value="0">Отрицательное</option>
									</select>
								</td>
								<td class='form_td'>
									<input v-on:click="pushLine" type="checkbox" v-model='line.f_83' :data-index='index' :disabled='readonly'></input>
								</td>
								<td class='form_td'>
									<input type="text" class='table-control form-control my-control' v-model='line.f_82' :disabled='readonly'></input>
								</td>
							</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-10 col"><b>Выездная проверка</b></div>
			</div>
			<div class="row">
				<div class="col-sm-10">
					<table class='documentsTable'>
						<thead>
							<tr>
								<th>Официальные документы</th>
								<th>Дата</th>
								<th>Номер</th>
								<th>Комментарий к документу</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Основание для проведения выездной проверки*</td>
								<td><datepicker
									v-model='f_60'
									format='dd.MM.yyyy'
									:disabled='readonly'
									:class='(f_71 != 3 && lines_copy.length && !f_60) ? "field-error-warrant" : "" '
									class='table-control'
								></datepicker></td>
								<td>
									<input 
										class="table-control form-control my-control"
										:class='(f_71 != 3 && lines_copy.length && !f_61) ? "field-error-warrant" : "" ' 
										v-model='f_61' 
										:disabled='readonly'>
									</input>
								</td>
								<td>
									<select 
									class='form-control my-control table-control' 
									:class='(f_71 != 3 && lines_copy.length && !f_62) ? "field-error-warrant" : "" ' 
									v-model='f_62' 
									:disabled='readonly'
									>
										<option value="Невозможность проверки обоснованности мероприятий">Невозможность проверки обоснованности мероприятий</option>
										<option value="Обращения граждан и юридических лиц">Обращения граждан и юридических лиц</option>
									</select>
								</td>
							</tr>
							<tr>
								<td>Приказ о проведении выездной проверки*</td>
								<td><datepicker
									v-model='f_63'
									format='dd.MM.yyyy'
									:disabled='readonly'
									:class='(f_71 != 3 && lines_copy.length && !f_63) ? "field-error-warrant" : "" ' 
									class='table-control'
								></datepicker></td>
								<td>
									<input 
										class="table-control form-control my-control" 
										:class='(f_71 != 3 && lines_copy.length && !f_64) ? "field-error-warrant" : "" ' 
										v-model='f_64' 
										:disabled='readonly'>
									</input>
								</td>
								<td><input class="table-control form-control my-control" v-model='f_65' :disabled='readonly'></input></td>
							</tr>
							<tr>
								<td>Акт проведения выездной проверки*</td>
								<td><datepicker
									v-model='f_66'
									format='dd.MM.yyyy'
									:disabled='readonly'
									:class='(f_71 != 3 && lines_copy.length && !f_66) ? "field-error-warrant" : "" ' 
									class='table-control'
								></datepicker></td>
								<td>
									<input 
										class="table-control form-control my-control"
										:class='(f_71 != 3 && lines_copy.length && !f_67) ? "field-error-warrant" : "" ' 
										v-model='f_67' 
										:disabled='readonly'>
									</input>
								</td>
								<td><input class="table-control form-control my-control" v-model='f_68' :disabled='readonly'></input></td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div style='margin-bottom: 20px'></div>
			<div class="row">
				<div class="col-sm-12">
					Результат выездной проверки
				</div>
			</div>
			<div class="row">
				<div class="col-sm-12">
					<table class='result_table'>
						<thead>
							<tr>
								<th rowspan='2' class="form_td">Участковое <br> лесничество</th>
								<th rowspan='2' class="form_td">Подлес-во</th>
								<th rowspan='2' class="form_td">Квартал</th>
								<th rowspan='2' class="form_td">Выдел</th>
								<th rowspan='2' class="form_td">Лп. выдел</th>
								<th rowspan='2' class="form_td">МЗЛ</th>
								<th rowspan='2' class="form_td">S МЗЛ</th>
								<th rowspan='2' class="form_td">критерии</th>
								<th rowspan='2' class="form_td">проверка</th>
								<th colspan="3" class='colspan_td'>решение по результатам выездной проверки*</th>
								<th rowspan='2' class="form_td">Комментарии</th>
							</tr>
							<tr>
								<th class="form_td">МЗЛ</th>
								<th class="form_td">S МЗЛ</th>
								<th class="form_td">Выявленные нарушение</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for='(line, index) in lines_copy' :key='line.index'>
								<td class='form_td'>
									<input type="text" class='table-control form-control my-control' v-model='line.f_20' disabled></input>
								</td>
								<td class='form_td'>
									<input type="text" class='table-control form-control my-control' v-model='line.f_27' disabled></input>
								</td>
								<td class='form_td'>
									<input type="text" class='table-control form-control my-control' v-model='line.f_17' disabled></input>
								</td>
								<td class='form_td'>
									<input type="text" class='table-control form-control my-control' v-model='line.f_24' disabled></input>
								</td>
								<td class='form_td'>
									<input type="text" class='table-control form-control my-control' v-model='line.f_25' disabled></input>
								</td>
								<td class='form_td'>
									<input type="text" class='table-control form-control my-control' v-model='line.f_16' disabled></input>
								</td>
								<td>
									<input type="text" class='table-control form-control my-control' v-model='line.f_22' disabled></input>
								</td>
								<td>
									<input class='form-control form-control my-control table-control' disabled></input>
								</td>
								<td>
									<input class='form-control form-control my-control table-control' disabled></input>
								</td>
								<td class='form_td'>
									<action-type :line_count='line.index' :data-index='line.index' :disabled='readonly'></action-type>
								</td>
								<td class='form_td'>
									<input 
										type="text" 
										class='table-control form-control my-control' 
										:class='(f_71 != 3 && !lines[line.index].f_85) ? "field-error-warrant" : "" ' 
										v-model='lines[line.index].f_85' 
										:disabled='readonly'>
									</input>
								</td>
								<td class="form_td">
									<discovered-violations :index='line.index' :ids='lines[line.index].f_110'></discovered-violations>
								</td>
								<td class='form_td'>
									<input type="text" class='table-control form-control my-control' v-model='lines[line.index].f_86' :disabled='readonly'></input>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div class="row" style='margin-top: 5px'>
				<div class="col-md-2 col">Итоговое решение</div>
				<div class="col-md-2 col">Нарушение пунктов постан. Прав-ва.1158</div>
				<div class="col-md-6 col">Нарушения НПА</div>
			</div>
			<div class="row">
				<div class="col-md-2 col">
					<select class='form-control my-control' :class='(f_71 != 3 && f_69 == 2) ? "field-error-warrant" : ""' v-model='f_69' :disabled='readonly' @change='mainDecisionChange($event)'>
						<option value="2">Нет данных</option>
						<option value="1">Положительное</option>
						<option value="0">Отрицательное</option>
					</select>
				</div>
				<div class="col-md-2 col">
					<input type="text" class="form-control height-control" v-model='npa_violation_text' disabled>
				</div>
				<div class="col-md-6">
					<npa-violation :npa_disabled='npa_disabled_comp' :ids='f_92'></npa-violation>
				</div>
			</div>
			<template v-if="f_69 == 0">
				<div class="row">
					<div class="col-md-5 col text-center" style="height: 24px; line-height: 24px;">Главная причина отмены акта</div>
				</div>
				<div class="row">
					<div class="col-md-5 col">
						<select 
							v-model="f_125" 
							:disabled="readonly || f_69 != 0"
							class="form-control my-control"
							:class='errorDecisionReason ? "field-error-warrant" : ""'
							@change="errorDecisionReasonHandler"
						>
							<option v-for="reason of decisions" :key="reason.id" :value="reason.id">
								{{ reason.name }}
							</option>
						</select>
					</div>
			</div>
			</template>
			<div class="row">
				<div class="col-md-10 col">Примечание</div>
			</div>
			<div class="row">
				<div class="col-md-10 col">
					<input type="text" class='form-control my-control' v-model='f_70' :disabled='readonly'></input>
				</div>
			</div>
			<div class="row">
				<div class="col-md-10">
					<table class='documentsTable'>
						<thead>
							<tr>
								<th>Официальные документы</th>
								<th>Дата</th>
								<th>Номер</th>
								<th>Комментарий к документу</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>
									<official-docs :disabled='readonly'></official-docs>
									<!--
									<select class='table-control form-control my-control' v-model='f_71' :disabled='readonly'>
										<option value="1">Предписание ДЛХ по ФО о внесении изменений в Акт ЛПО</option>
										<option value="2">Предписание ДЛХ по ФО об отмене Акта ЛПО</option>
									</select> -->
								</td>
								<td><datepicker
									v-model='f_72'
									format='dd.MM.yyyy'
									:disabled='readonly'
									class='table-control'
								></datepicker></td>
								<td><input class="table-control form-control my-control" v-model='f_73' :disabled='readonly'></input></td>
								<td><input class="table-control form-control my-control" v-model='f_74' :disabled='readonly'></input></td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="col-md-2">
				<select v-model='f_75' class='form-control form-control my-control medium' :disabled='readonly'>
					<option value="1">Черновик</option>
					<option value="0">Чистовик</option>
				</select>
			</div>
			</div>
			<div class="row" style='margin: 5px;'></div>
			<hr>

			<div class='btnPanel'>
				<!-- <b-button class='clearBtn' variant='secondary'>Очистить</b-button> -->
				<input type='button' class='btn btn-secondary' @click.prevent="close" value='Отмена' :disabled='readonly'></input>
				<input type='button' class='btn btn-primary' @click='submit' value='Сохранить' :disabled='readonly'></input>
			</div>
	</form>

	
</template>

<script>
	import router from '../../router'
	import auth from '../../auth'

	import region from '../edit/fetch_data/region'
	import organization from '../edit/fetch_data/organization'
	import fo from '../edit/fetch_data/fo'

	import forestry from './fetch_data/forestry'
	import localforestry from './fetch_data/localforestry'
	import subforestry from './fetch_data/subforestry'
	import actionType from './fetch_data/actionType'
	import warrantTableField from './fetch_data/warrantTableField'
	
	import npaViolation from './fetch_data/npaViolation'
	import officialDocs from './fetch_data/officialDocs'
	import discoveredViolations from './fetch_data/discoveredViolations'

	import moment from 'moment';
	// import jQuery from "jquery"; 
	// import datePicker from 'vue-bootstrap-datetimepicker';

	import { datepicker } from 'vue-strap'

	import { EventBus } from '../../lib/EventBus'

	import {DB} from './../../constants'
	const HEADER = 'get_header.php'
	//const LOCATION = 'get_location.php'
	const ACT_DECISION = 'get_act_decision.php'
	const WARRANT_LOCATION = 'get_warrant_location.php'
	const WARRANT_INFO = 'get_warrant_info.php'
	const CAN_EDIT = 'can_edit_unit.php'
	const REASON = 'get_decision_reason.php'
	const UNIT_ID = 3
	// const INSERT_JSON = 'insert_json.php'
	const UPDATE_JSON = 'update_json.php'
	// const DELETE_JSON = 'delete_json.php'
	// const GET_WARRANT_PARENT = 'get_warrant_parent.php'
	//const JSON_U2 = 'get_json_u2.php'

	export default {
		name: 'warrantModal',
		data: function () {
			return {
				scroll_width: 17,
				readonly: true,
				line_count: 0,
				lines: [],
				lines_copy: [],
				act_id: '',
				
				f_2: '',
				f_4: '', 
				f_11: '',
				f_9: '',
				f_12: '',
				
				f_20: [], 
				f_27: [],
				f_16: [],
				f_17: [],
				f_24: [],
				f_25: [],

				location_id: [],  //f_0
				f_21: [],
				f_22: [],
				f_23: [],
				f_41: [],

				f_42: 0,
				f_42_text: '',

				f_76: [],
				f_77: [],
				f_78: [],
				f_79: [],
				f_80: [],
				f_81: [],
				f_82: [],
				f_83: [],
				f_84: [],
				f_85: [],
				f_86: [],

				f_51: '',
				f_52: '',
				f_53: '',

				f_54: '',
				f_55: '',
				f_56: '',

				f_57: '',
				f_58: '',
				f_59: '',

				f_60: '',
				f_61: '',
				f_62: '',

				f_63: '',
				f_64: '',
				f_65: '',

				f_66: '',
				f_67: '',
				f_68: '',

				f_69: 2,
				f_70: '',

				f_71: 1,

				f_72: '',
				f_73: '',
				f_74: '',

				f_75: 1,
				
				f_87: auth.user.id,
				
				f_92: '',

				npa_violation_text: '',
				npa_disabled: true,

				decisions: [],
				errorDecisionReason: false,
				f_125: ''
			}
		},
		computed: {
			npa_disabled_comp() {
				let f_79 = false
				let f_81 = false
				for(let line of this.lines){
					f_79 = (line.f_79 == 0) || f_79
					f_81 = (line.f_81 == 0) || f_81
				}
				if(this.f_69 == 0 && f_79 && f_81)
					return false
				else
					return true
			}
		},
		components: {
			region,
			forestry,
			localforestry,
			subforestry,
			organization,
			fo,
			actionType,
			datepicker,
			npaViolation,
			officialDocs,
			discoveredViolations,
			warrantTableField
		},	
		watch: {
			//[35,36,38,39,44,45,48,49]
			lines: {
				handler: function () {
					this.errorDecisionReasonHandler()
				},
				deep: true
			}
		},
		methods: {
			errorDecisionReasonHandler () {
				this.errorDecisionReason = false
				if(Number(this.f_69) == 0)
				{
					let array = []

					for(let line of this.lines)
					{
						for(let i = 76; i <= 80; i++)
						{
							array[i] = array[i] || (line[`f_${i}`] == 0)
						}
					}

					if(this.f_125 == 1)
						this.errorDecisionReason = !array[79]
					if(this.f_125 == 2)
						this.errorDecisionReason = !array[78]
					if(this.f_125 == 3)
						this.errorDecisionReason = !array[76]
					if(this.f_125 == 4)
						this.errorDecisionReason = !array[77]
					if(!this.f_125)
						this.errorDecisionReason = true
				}
			},
			setAccordanceToLocations (data) {
				for(let line in this.lines) {
					this.lines[line][data.field] = data.value
				}
					
			},
			mainDecisionChange (e) {
				this.f_69 = e.target.value
				this.errorDecisionReasonHandler()
				/*if(e.target.value == 0 || e.target.value == 1)
					for(let line in this.lines)
					{
						this.lines[line].f_76 = this.f_69
						this.lines[line].f_77 = this.f_69
						this.lines[line].f_78 = this.f_69
						this.lines[line].f_79 = this.f_69
						this.lines[line].f_80 = this.f_69
						this.lines[line].f_81 = this.f_69
						//this.lines[line][`correct_f_33`] = 'place-success'
					}*/
			},
			pushLine (e) {
				let index = e.target.getAttribute('data-index')

				if (e.target.checked) {
					let place = {}

					place.index = index
					for (let i = 16; i <= 27; i++) {
						//console.log(i,this.lines[index][`f_${i}`])
						place[`f_${i}`] = this.lines[index][`f_${i}`]
					}

					this.lines_copy.push(place)
				}
				else {
					//console.warn(this.lines_copy)
					let lines_temp = this.lines_copy.filter((item) => {
						return item.index != index
					})

					this.lines_copy = lines_temp
					//console.warn(this.lines_copy)
				}
				this.$forceUpdate()
			},
			checkFields () {
				let have_negative = false
				for(let line of this.lines) {
					if(!(line.f_76 && line.f_77 && line.f_78 && line.f_79 && line.f_80 && line.f_81)) {
						have_negative = true
						break
					}
				}
				
				if((this.f_69 == 0 && !have_negative) || (this.f_69 == 1 && have_negative))
					return false

				return true
			},
			submit () {
				if(document.querySelector('.field-error-warrant') !== null) {
					alert('Часть полей содержит некорректные данные. Сохранение невозможно')
					return;
				}

				if(document.querySelector('.field-error-warrant-optional') !== null || !this.checkFields()) {
					const answer = confirm('Часть полей может содержать некорректную информацию. Вы уверены, что хотите сохранить?')
					if(!answer)
						return;
				}

				let obj = [{}]
				obj[0].tab_id = 1
				obj[0].f_v = {}
				obj[0].f_v.f_c = this.$route.params.id
				
				for (let i = 51; i <= 75; i++) {
					if (typeof this[`f_${i}`] !== 'object') {
						if (i === 69 || i === 75)
							obj[0].f_v[`f_${i}`] = this[`f_${i}`] != '2' ? (this[`f_${i}`] == '1' ? true : false) : null
						else if (i === 52 || i === 55 || i === 58 || i === 61 || i === 64 || i === 67 || i === 73)
							obj[0].f_v[`f_${i}`] = this[`f_${i}`] ? commaToPeriod(this[`f_${i}`]) : null
						else
							obj[0].f_v[`f_${i}`] = this[`f_${i}`] ? this[`f_${i}`] : null
					}
					else {
						obj[0].f_v[`f_${i}`] = this[`f_${i}`] ? this[`f_${i}`].format('DD.MM.YYYY') : null
					}
				}
				obj[0].f_v.f_87 = this.f_87
				obj[0].f_v.f_125 = this.f_125 || null
				

				if (this.f_92.length)
				{
					if(this.f_92[0] == '{' && this.f_92[this.f_92.length - 1] == '}')
					{
						obj[0].f_v.f_92 = this.f_92
					} else 
					{
						obj[0].f_v.f_92 = `{${this.f_92.join(',')}}`
					}
				}
				else
					obj[0].f_v.f_92 = null

				for (let i = 0; i < this.lines.length; i++) {
					obj.push({})

					obj[i + 1].tab_id = 2
					obj[i + 1].f_v = {}
					obj[i + 1].f_v.f_c = this.lines[i].f_c

					for (let j = 76; j <= 81; j++) {
						if ( this.lines[i][`f_${j}`] != '2')
							obj[i + 1].f_v[`f_${j}`] = this.lines[i][`f_${j}`] == '1' ? true : false
						else
							obj[i + 1].f_v[`f_${j}`] = null
					}

					obj[i + 1].f_v.f_82 = this.lines[i].f_82 ? this.lines[i].f_82 : null
					obj[i + 1].f_v.f_83 = this.lines[i].f_83
					obj[i + 1].f_v.f_110 = this.lines[i].f_110 ? this.lines[i].f_110 : null
					
					//obj[i + 1].f_v.f_110 = this.lines[i].f_110 ? `{${this.lines[i].f_110.join(',')}}` : null

					for (let j = 84; j <= 86; j++) {
						if (j === 85) {
							obj[i + 1].f_v.f_85 = this.lines[i].f_85 ? commaToPeriod(this.lines[i].f_85) : null
						}
						else {
							obj[i + 1].f_v[`f_${j}`] = this.lines[i][`f_${j}`] ? this.lines[i][`f_${j}`] : null
						}
					}
				}
				// console.log(JSON.stringify(obj)) 

				let form = new FormData()
				form.append('json', JSON.stringify(obj))

				fetch(DB + UPDATE_JSON, {
					credentials: 'include',
					method: 'post',
					body: form
				})
				.then(result => result.json())
				.then(result => {
					if(result[0].code === '0') {
						alert('Предписание сохранено')
						
						if(this.$parent.lastJournalURL)
							router.replace(this.$parent.lastJournalURL)
						else
							router.replace('/main')
					}
					else {
						alert(result[0].name)
					}
				})
				.catch(err => console.log(err))

			},
			close () {
				if(this.$parent.lastJournalURL)
					router.replace(this.$parent.lastJournalURL)
				else
					router.replace('/main')
			},
			updateViolations() {
				let npa_violations = []
				const npa_list = {
					'f_76': '4а',
					'f_77': '4б',
					'f_78': '5б',
					'f_79': '8в',
					'f_80': '8а',
				}

				const discovered_list = {
					'1': '8а',
					'2': '8б',
					'3': '8в'
				}

				for (let i = 0; i < this.lines.length; i++) {
					for (let j = 76; j <= 80; j++) {
						if (this.lines[i][`f_${j}`] == '0') {
							if(!npa_violations.includes(npa_list[`f_${j}`]))
								npa_violations.push(npa_list[`f_${j}`])
						}
					}

					var row = this.lines[i]
					if(row.f_83)
					{
						let list = row.f_110 ? row.f_110.slice(1,-1).split(',') : undefined
						if(list)
						{
							for(let e of list)
							{
								if(e)
									if(!npa_violations.includes(discovered_list[e]))
										npa_violations.push(discovered_list[e])
							}
						}
					}
				}

				this.npa_violation_text = npa_violations.sort().join(', ')
				
				/*
				for (let key in npa_violations) {
					text = text + npa_violations[key] + ', '
				}*/

				//if (text.length > 2)
				//	this.npa_violation_text = text.slice(0,-2)
				//else
				//	 = ''

				//this.npa_disabled = typeof npa_violations.f_79 == 'undefined'
			}
		},
		created () {
			EventBus.$on('warrant_action_type', data => {
				this.lines[data.index].f_84 = data.value
			})

			EventBus.$on('warrant_npa_violation_ids', ids => {
				this.f_92 = ids
			})

			EventBus.$on('official_docs', id => {
				this.f_71 = id
			})

			EventBus.$on('warrant_discovered_violations', data => {
				this.lines[data.index].f_110 = data.ids ? `{${data.ids.join(',')}}` : null
				this.updateViolations()
			})

			EventBus.$on('warrant_discovered_violations_update', () => {
				this.updateViolations()
			})

			fetch(DB + REASON, {
				credentials: 'include'
			})
			.then(res => res.json())
			.then(res => {
				this.decisions = res
			})

			fetch(DB + CAN_EDIT + '?act_id=' + this.$route.params.id + '&unit_id=' + UNIT_ID, {
				credentials: 'include'
			})
			.then(res => res.json())
			.then(res => {
				// console.log(res)
				this.readonly = res[0].czl_check_can_edit_unit == 't' ? false : true
			})
			.catch(err => console.log(err))

			fetch(DB + HEADER + '?id=' + this.$route.params.id, {
				credentials: 'include'
			})
			.then(res => res.json())
			.then(res => {
				for (let i in res[0]) {
					this[i] = res[0][i]
				}
			})
			.catch(err => console.log(err))

			fetch(DB + WARRANT_LOCATION + '?id=' + this.$route.params.id, {
				credentials: 'include'
			})
			.then(res => res.json())
			.then(res => {
				if (res) {
					this.lines = res
				}

				let row_count = 0

				let npa_violations = {}
				const npa_list = {
					'f_76': '4а',
					'f_77': '4б',
					'f_78': '5б',
					'f_79': '8в',
					'f_80': '8а',
				}

				for (let i = 0; i < res.length; i++) {
					for (let j = 76; j <= 80; j++) {
						if (res[i][`f_${j}`] && (res[i][`f_${j}`] === 'f')) {
							npa_violations[`f_${j}`] = npa_list[`f_${j}`]
						}
					}

					for (let j = 76; j <= 81; j++) {
						this.lines[i][`f_${j}`] = res[i][`f_${j}`] ? ((res[i][`f_${j}`] === 't') ? 1 : 0) : 2
					}
					this.lines[i].f_33 = res[i].f_33 ? (res[i].f_33 === 't' ? 1 : 0) : 2
					this.lines[i].f_91 = res[i].f_91 ? (res[i].f_91 === 't' ? true : false) : false
					this.lines[i].f_c = res[i].f_c

					if (res[i].f_83 === 't') {
						this.lines[i].f_83 = true
						let place = {}

						place.index = row_count
						for (let k = 16; k <= 27; k++) {
							place[`f_${k}`] = this.lines[i][`f_${k}`]
						}

						this.lines_copy.push(place)
					}
					else {
						this.lines[i].f_83 = false
					}
					row_count++
				}
				
				let text = ''
				for (let key in npa_violations) {
					text = text + npa_violations[key] + ', '
				}
				if (text.length > 2)
					this.npa_violation_text = text.slice(0,-2)
				else
					this.npa_violation_text = ''

				this.npa_disabled = typeof npa_violations.f_79 == 'undefined'
			})
			.catch(err => console.log('9',err))

			fetch(DB + WARRANT_INFO + '?id=' + this.$route.params.id, {
				credentials: 'include'
			})
			.then(res => res.json())
			.then(res => {
				for (let i in res[0]) {
					if (res[0][i]) {
						if (i === 'f_51' || i === 'f_54' || i === 'f_57' || i === 'f_60' || i === 'f_63' || i === 'f_66' || i === 'f_72') {
							let d = moment(res[0][i], 'YYYY-MM-DD')
							// console.log(res[0][i], d.format('DD.MM.YYYY'))
							this[i] =  res[0][i] ? d.format('DD.MM.YYYY') : ''
						}
						else if (i === 'f_75' || i === 'f_69') {
							this[i] = res[0][i] === 't' ? 1 : 0
						}
						else {
							this[i] = res[0][i]
						}
					}
				}
			})
			.catch(err => console.log(err))
			
			const ua = navigator.userAgent

			if (ua.search('OPR/') > 0) {
				this.scroll_width = 15
			}
		},
		beforeDestroy () {
			EventBus.$off('warrant_action_type')
			EventBus.$off('warrant_npa_violation_ids')
			EventBus.$off('official_docs')
			EventBus.$off('warrant_discovered_violations')
			EventBus.$off('warrant_discovered_violations_update')
		}
	}

	function commaToPeriod(str) {
		return str.replace(/,/g, ".")
	}
</script>

<style scoped>
	.fbu_main_decision {
		font-size: 13px;
		text-align: left !important;
		padding-left: 30px;
		margin-top: 10px;
	}
	select option {
		background: #fff !important;
	}
</style>

<style>
	.field-error-warrant,
	.field-error-warrant-optional,
	.field-error-warrant > input,
	.field-error-warrant-optional > input {
		background-color: #ffd5d5 !important;
	}

	.act_link {
		display: flex;
		align-items: center;
		height: 24px;
		justify-content: flex-start;
		overflow: hidden;
	}

	div.datepicker {
		width: 100%;
	}

div.datepicker.table-control > input.form-control {
	border: none !important;
	height: 24px;
	margin: 0px;
	display: inline-table !important;
}

	.warrant_place_table .table-control {
		font-size: 9px !important;
	}
	
	.warrant_place_table td.form_td {
		font-size: 9px;
		border-top: none;
		/*width: 5%;*/
	}

	.warrant_place_table tr, .warrant_place_table th.form_td{
		border-collapse: collapse;
		text-align: center;
		font-size: 9px;		
		/*width: 5%;*/
	}

	.warrant_place_table tr, .warrant_place_table td.form_td_chkbox {
		/*width: 1%;*/
		border-top: none;
	}

	.warrant_place_table tr, .warrant_place_table th.form_td_chkbox {
		/*width: 1%;*/
	}

	.warrant_place_table {
		margin-bottom: 5px;
		border: 1px solid;
		width: 100%;
	}

	.result_table {
		width: 100%;
		table-layout: fixed;
	}

	.result_table th.form_td, .result_table td.form_td{
		border-collapse: 1px;
		text-align: center;
		/*width: 8%;*/
	}

	.form-control my-control {
		padding-left: 5px !important;
		padding-top: 0px !important;
		padding-bottom: 0px !important;
		margin-bottom: 5px;
		height: 24px;
		display: inline-table !important;
		font-size: 12px !important;
	}

	select.form-control my-control:not([size]):not([multiple]) {
		height: 24px;
	}

	.table-control {
		height: 24px;
		width: 100%;
		margin: 0px;
		border: none !important;
	}

	
</style>


// WEBPACK FOOTER //
// warrantForm.vue?3b4cd72b